import { Container as ContainerChakra, ContainerProps } from "@chakra-ui/react";

export default function Container(props: ContainerProps) {
  return <ContainerChakra maxWidth="1200px" {...props} />;
}
